import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { commonType } from "..";
import DataNotFound from "../../../../components/Data Not Found";
import Pagination from "../../../../components/Pagination";
import DeleteModal from "../../../../components/Trashed Modal/DeleteModal";
import CalendarFilter2 from "../../../../Filters/CalendarFilter2";
import useLoading from "../../../../hooks/useLoading";
import { getLead, restoreLead } from "../../../../lib/api functions/lead/lead";
import { showToast } from "../../../../lib/toast/ShowToast";
import ShowSelectedDate from "../../../../shared components/DateInput/ShowSelectedDate";
import SkeletonLoader from "../../../../shared components/Loader/SkeletonLoader";
import Search from "../../../../shared components/Search";
import { DELETE_LEAD_HARD } from "../../../../utils/constants";
import { MainContext } from "../../../../utils/private_routes/PrivateRoutes";
import { ParamType } from "../type";

const Lead = () => {
  const { setPageTitle, companyId, userId, roles, setting } =
    useContext(MainContext);
  const [commonData, setCommonData] = useState<commonType>({
    data: undefined,
    modal: false,
    check: "",
  });
  const [loading, showLoader, hideLoader] = useLoading();
  const [leads, setLeads] = useState<any>([]);
  const [totalResult, setTotalResult] = useState<number>(0);
  const [params, setParams] = useState<ParamType>({
    page: 1,
    per_page: 10,
    company: companyId,
    isDeleted: true,
  });

  const fn = {
    openModal: (data?: any, check?: string) => {
      setCommonData({
        data: data,
        modal: true,
        check: check,
      });
      document.body.style.overflow = "hidden";
    },
    getLeads: async (params: ParamType) => {
      showLoader();
      const res = await getLead(params);
      if (res) {
        setLeads(res.data.leads);
        setTotalResult(res.data.total);
        hideLoader();
      }
    },
    restoreLead: async (leadId: string) => {
      let finalObj = {
        leadIds: [leadId],
        isDeleted: false,
      };
      const res = await restoreLead(finalObj, hideLoader);
      if (res) {
        showToast(`Lead Restored`, "success");
        fn.getLeads(params);
      }
    },
  };

  useEffect(() => {
    if (roles?.length !== 0) {
      if (!roles[0]?.leads.complete) {
        params.user = userId;
        fn.getLeads(params);
      } else {
        fn.getLeads(params);
      }
    }
  }, []);

  useEffect(() => {
    setPageTitle("Trashed Lead");
  }, []);

  return (
    <>
      <div className="single_page">
        <div className="data_render_wrapper">
          {/* filters */}
          <div className="filter_wrapper">
            <div className="container-fluid p-0">
              <div className="row align-items-center">
                <div className="col-12 col-lg-4">
                  <Search
                    placeholder="Search by contact person name"
                    state={params}
                    setState={setParams}
                    apiCall={fn.getLeads}
                    paramValue="name"
                  />
                </div>
                <div className="col-12 col-lg-8 pt-3 pt-lg-0">
                  <div className="d-flex align-items-center gap-3 justify-content-start justify-content-lg-end">
                    {params?.start_date && params?.end_date && (
                      <>
                        <ShowSelectedDate
                          label="From:"
                          value={moment(params?.start_date).format(
                            setting?.dateFormat
                          )}
                        />
                        <ShowSelectedDate
                          label="To:"
                          value={moment(params?.end_date).format(
                            setting?.dateFormat
                          )}
                        />
                      </>
                    )}

                    <div className="d-flex gap-2">
                      <CalendarFilter2
                        state={params}
                        apiCall={fn.getLeads}
                        setState={setParams}
                        isFutureDateRequired={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="list_view_wrapper">
            <div className="container-fluid p-0">
              <div className="row align-items-center pb-3">
                <div className="col-12">
                  <span className="font16x600 textColor3">
                    List of Trashed Leads
                  </span>
                </div>
              </div>
            </div>

            {/* table */}
            {leads?.length !== 0 ? (
              <div className="entry_table_wrapper">
                <div className="table_wrapper">
                  <table className="table">
                    <thead className="table_head">
                      <tr className="font12x500 textColor3">
                        <th scope="col">#</th>
                        <th scope="col">Entry Date</th>
                        <th scope="col">Lead Details</th>
                        <th scope="col">Contact</th>
                        <th scope="col">Last Updated</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leads?.map((lead: any, i: number) => {
                        return (
                          <tr key={i} className="font12x400">
                            <th>
                              {(params.page - 1) * params.per_page + (i + 1)}
                            </th>
                            <td>
                              {moment(lead?.createdAt).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>
                              <span className="textColor2 mb-1">
                                {lead?.name}
                              </span>
                              <br />
                              <span>{lead?.client?.name}</span>
                            </td>
                            <td>
                              <span className="textColor2 mb-1">
                                {lead?.email}
                              </span>
                              <br />
                              <span>{lead?.mobile}</span>
                            </td>
                            <td>
                              {moment(lead?.updatedAt).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-3">
                                <button
                                  className="btn font12x500 buttonTwo shadow-none"
                                  onClick={() => fn.restoreLead(lead?._id)}
                                >
                                  Restore
                                </button>
                                <div
                                  className="cursor_pointer"
                                  onClick={() =>
                                    fn.openModal(
                                      { leadIds: [lead?._id] },
                                      "delete"
                                    )
                                  }
                                >
                                  <img
                                    src="/Assets/Svg/deleteColor.svg"
                                    alt="close"
                                    className="img-fluid"
                                    draggable={false}
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : loading ? (
              <SkeletonLoader />
            ) : (
              <DataNotFound />
            )}
          </div>
        </div>

        {/* pagination */}
        {leads?.length !== 0 && (
          <div className="pagination_wrapper pt-3 px-3">
            <Pagination
              currentPage={params.page}
              onPageChange={(e) => {
                fn.getLeads({ ...params, page: e });
                setParams({
                  ...params,
                  page: e,
                });
              }}
              pageSize={params.per_page}
              totalCount={Math.ceil(totalResult / params.per_page)}
              onChangePerPage={(e) => {
                fn.getLeads({ ...params, per_page: e });
                setParams({
                  ...params,
                  per_page: e,
                });
              }}
            />
          </div>
        )}
      </div>

      {/* delete modal */}
      {commonData?.modal && commonData?.check === "delete" && (
        <DeleteModal
          label="Lead"
          dataIds={commonData?.data}
          setState={setCommonData}
          url={DELETE_LEAD_HARD}
          variableName="leadIds"
          apiCall={fn.getLeads}
          params={params}
        />
      )}
    </>
  );
};

export default Lead;
